<template>
  <div class="mb-16 molecule categories">
    <h3 class="mb-2 text-lg font-medium text-gray-800 font-ubuntu">Category</h3>
    <ul>
      <li
        v-for="category in molecule.categories"
        :class="[
          'text-gray-500 border-b border-gray-300 hover:bg-gray-100',
          !category.count ? 'hidden' : '',
        ]"
        :data-count="category.count"
      >
        <a :href="category.uri" class="flex justify-between py-4">
          <span class="block">{{ category.title }}</span>
          <span class="block">({{ category.count ?? 0 }})</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<style>
.molecule.categories {
}
</style>

<script setup>
const props = defineProps({
  molecule: Object,
});
</script>
